// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"181":"c47ab2da","337":"38cce425","652":"209af657","694":"0d0c8293","841":"48d6ede7","887":"80f7ca5b"}[chunkId] + ".chunk.css";
};